import React, { useEffect, useState } from "react";
import "./techmoonshots.css";
import client from "../../../utils/prismicHelpers";
import * as queries from "../../../utils/prismicQueries";
import BreadCrumb from "../../../main/components/BreadCrumb";
import ReactPlayer from "react-player";
import logo from "../../../assets/images/features-logo.png";
import logo2 from "../../../assets/images/market.png";
import FeaturesCard from "./FeaturesCard";

const TechMoonshots = () => {
  const [techmoonshots, setTechmoonInfo] = useState(null);

  useEffect(() => {
    client
      .query({
        query: queries.techmoonshots,
      })
      .then((response) => {
        const techMoonDoc = response.data.allTech_moonshotss.edges[0].node;
        setTechmoonInfo(techMoonDoc);
        window.scrollTo(0, 0);
      })
      .catch((error) => {
        console.error(error);
      });
  });

  return (
    <section
      style={{ backgroundImage: `url(${techmoonshots?.section_bg?.url})` }}
      className="news-container "
    >
      <div className="container">
        <BreadCrumb nested={"Tech Moonshots"} />
        <h3 className="subtitle">{techmoonshots?.title}</h3>
        <p className="tecmon-title">{techmoonshots?.subtitle}</p>
        <div className="tech-description">
          <div className="row">
            <div className="col-md-6">
              <p>{techmoonshots?.des1}</p>
            </div>
            <div className="col-md-6">
              <p> {techmoonshots?.des2}</p>
            </div>
          </div>
        </div>
        <div>
          <h3 className="subtitle my-1">{techmoonshots?.video_title}</h3>
          <div className="row">
            <div className="col-md-8">
              <ReactPlayer
                className="react-player"
                url={techmoonshots?.video_link?.embed_url}
                playing={true}
                light={techmoonshots?.video_link?.thumbnail_url}
                volume={1}
                width="90%"
                height="400px"
              />
            </div>
          </div>
        </div>
        <div className="fly-ambulance-service mt-5 pb-3">
          <p>{techmoonshots?.features_title}</p>
          <div className="row g-3">
            {techmoonshots?.features?.map((info, index) => (
              <FeaturesCard key={index + 1} logo={logo} info={info} />
            ))}
          </div>
        </div>
        <div className="fly-ambulance-service mt-2">
          <p>{techmoonshots?.service_title}</p>
          <div className="row g-3">
            {techmoonshots?.services?.map((info, index) => (
              <FeaturesCard key={index + 1} logo={logo2} info={info} />
            ))}
          </div>
        </div>
        <div className="techmoon-footer">
          <p>{techmoonshots?.footer_text}</p>
        </div>
        <h3 className=" footer-email mt-4  ">
          {techmoonshots?.footer_email.slice(0, 12)}
          <a
            rel="noreferrer"
            target="_blank"
            href={"mailto:" + techmoonshots?.footer_email.slice(12, 100)}
          >
            {techmoonshots?.footer_email.slice(12, 100)}
          </a>
        </h3>
      </div>
    </section>
  );
};

export default TechMoonshots;
